(() => {
  function getVariantsFromPicker(picker) {
    // Ride/Dawn style: variants array is usually in a JSON script that is NOT data-selected-variant
    const script =
      picker.querySelector('script[type="application/json"]:not([data-selected-variant])') ||
      picker.querySelector('script[type="application/json"]');

    if (!script) return null;

    try {
      const data = JSON.parse(script.textContent);

      // Could be { variants: [...] } or just [...]
      if (Array.isArray(data)) return data;
      if (data && Array.isArray(data.variants)) return data.variants;
    } catch (e) {}

    return null;
  }

  function getSelectedOptions(picker) {
    const selections = [];
    picker.querySelectorAll('fieldset').forEach((fs) => {
      const checked = fs.querySelector('input[type="radio"]:checked');
      selections.push(checked ? checked.value : null);
    });
    return selections;
  }

  function variantExists(variants, selected, optionIndex, candidate) {
    return variants.some((v) => {
      const opts = v.options || [];
      if (opts[optionIndex] !== candidate) return false;

      for (let i = 0; i < selected.length; i++) {
        if (i === optionIndex) continue;
        if (!selected[i]) continue;
        if (opts[i] !== selected[i]) return false;
      }
      return true;
    });
  }

  function findLabelForRadio(picker, radio) {
    // Your markup uses <label for="radio-id"> as a sibling
    try {
      return picker.querySelector(`label[for="${CSS.escape(radio.id)}"]`);
    } catch {
      // Fallback if CSS.escape isn't supported
      return picker.querySelector(`label[for="${radio.id}"]`);
    }
  }

  function updatePicker(picker) {
    const variants = getVariantsFromPicker(picker);
    if (!variants) return;

    const selected = getSelectedOptions(picker);
    const fieldsets = Array.from(picker.querySelectorAll('fieldset'));

    fieldsets.forEach((fs, optionIndex) => {
      fs.querySelectorAll('input[type="radio"]').forEach((radio) => {
        const label = findLabelForRadio(picker, radio);
        if (!label) return;

        const show = variantExists(variants, selected, optionIndex, radio.value);
        label.style.display = show ? '' : 'none';
      });
    });
  }

  function init() {
    document.querySelectorAll('variant-selects, variant-radios').forEach((picker) => {
      updatePicker(picker);

      picker.addEventListener('change', () => {
        setTimeout(() => updatePicker(picker), 0);
      });

      new MutationObserver(() => updatePicker(picker)).observe(picker, {
        childList: true,
        subtree: true,
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();